module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/justyna-kubiak-82e2adbd6f7d98b2ef2b52aaa25c5f0a.png";